import styled from 'styled-components';
import { SkeletonMarketSelections } from '../../sportsbook-market-selections-floating';
import { GAME_CARD_BREAKPOINT, GameCardWrapper } from './sportsbook-game-card-base';
import { Skeleton } from '@comeon/ui';
import { ScoreboardSkeleton } from '../../event-scoreboard';
import { FC } from 'react';

const StyledGameCardWrapper = styled(GameCardWrapper)`
	overflow: hidden;
	border-radius: var(--base-radius-large);
	@container (min-width: ${GAME_CARD_BREAKPOINT}px) {
		grid-template-columns: 1fr 1fr;
	}
`;
const StyledSkeletonMarketSelection = styled(SkeletonMarketSelections)`
	grid-column: span 2;

	@container (min-width: ${GAME_CARD_BREAKPOINT}px) {
		grid-column: 2;
	}
`;

const StyledGameCardDetails = styled.div`
	width: 100%;
	grid-column: 2;

	@container (min-width: ${GAME_CARD_BREAKPOINT}px) {
		grid-column: span 2;
	}
`;

const SkeletonGameCard: FC = () => {
	return (
		<StyledGameCardWrapper>
			<StyledGameCardDetails>
				<Skeleton width="60px" height="16px" />
			</StyledGameCardDetails>
			<ScoreboardSkeleton />
			<StyledSkeletonMarketSelection columnCount={3} />
		</StyledGameCardWrapper>
	);
};

export default SkeletonGameCard;
